export const disableEmailPasswordAuthentication =
  import.meta.env.VITE_DISABLE_EMAIL_PASSWORD_AUTHENTICATION === "true";

/** Signup stays off until multi-user is explicitly allowed. */
export const signupEnabled = import.meta.env.VITE_ENABLE_SIGNUP === "true";

export const googleWorkplaceDomain: string | undefined = import.meta.env
  .VITE_GOOGLE_WORKPLACE_DOMAIN;
